// Names of shared IndexedDB KV slots read from BOTH the app and the service
// worker bundle (sw/sw.ts headless decline). A leaf module with no imports so
// the SW can depend on it without dragging app code into its bundle — and so
// the two sides can never silently drift apart.

/** Encrypted refresh-token slot (storage/accountStore.ts SecretStore). */
export const REFRESH_SECRET_KEY = 'refresh-token';

/** Persisted signed endpoint-list state (shell/browserAdapters.ts). */
export const ENDPOINTS_STATE_KEY = 'endpoint-list-state';
